import React, { type JSX, memo } from 'react';

import TypographyLink from '@fmbt/ui/TypographyLink';

// ==============================
// TYPES
// ==============================
type LearnMoreLinkProps = {
  href: string;
  id?: string;
};

type LearnMoreLinkInTooltipProps = {
  href: string;
};

// ==============================
// COMPONENTS
// ==============================
function LearnMoreLink(props: LearnMoreLinkProps): JSX.Element {
  const { href, id } = props;
  return (
    <TypographyLink href={href} id={id} target="_blank" underline>
      Learn more
    </TypographyLink>
  );
}

/** “Learn more” link for use inside an antd **Tooltip** title (`TypographyLink` with tooltip styling). */
function LearnMoreLinkInTooltip(props: LearnMoreLinkInTooltipProps): JSX.Element {
  const { href } = props;
  return (
    <TypographyLink customColor="darkSurface" href={href} target="_blank" underline>
      Learn more
    </TypographyLink>
  );
}

export default memo(LearnMoreLink);
export { LearnMoreLinkInTooltip };